import React from 'react';
import Icon from '../../../components/AppIcon';

const Timeline = () => {
  const milestones = [
    {
      year: "2020",
      title: "The Beginning",
      description: "Chapati Plus opened its doors in Juba with a small team of 5 passionate individuals and a big dream to serve quality food.",
      icon: "Sparkles",
      color: "primary"
    },
    {
      year: "2021",
      title: "Community Recognition",
      description: "Won \'Best New Restaurant\' award from Juba Food Association. Expanded menu to include traditional South Sudanese dishes.",
      icon: "Award",
      color: "secondary"
    },
    {
      year: "2022",
      title: "Digital Innovation",
      description: "Launched WhatsApp ordering system, making us the first restaurant in Juba to offer seamless mobile ordering experience.",
      icon: "Smartphone",
      color: "accent"
    },
    {
      year: "2023",
      title: "Team Growth",
      description: "Expanded to 25 team members, all locally hired. Introduced delivery service covering major areas of Juba.",
      icon: "Users",
      color: "primary"
    },
    {
      year: "2024",
      title: "Quality Certification",
      description: "Received South Sudan Food Safety Certification. Partnered with local farmers for fresh ingredient sourcing.",
      icon: "ShieldCheck",
      color: "accent"
    },
    {
      year: "2025",
      title: "Community Impact",
      description: "Served over 10,000 customers. Launched community feeding program supporting local schools and charities.",
      icon: "Heart",
      color: "secondary"
    },
    {
      year: "2026",
      title: "Continued Excellence",
      description: "Expanding our reach while maintaining the quality and authenticity that made us a neighborhood favorite.",
      icon: "TrendingUp",
      color: "primary"
    }
  ];

  const getColorClass = (color) => {
    const colors = {
      primary: "bg-primary/10 text-primary",
      secondary: "bg-secondary/10 text-secondary",
      accent: "bg-accent/10 text-accent"
    };
    return colors?.[color] || colors?.primary;
  };

  return (
    <section className="py-12 md:py-16 lg:py-20 bg-background">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-8 md:mb-12">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground mb-3 md:mb-4">
            Our Journey
          </h2>
          <p className="text-base md:text-lg text-muted-foreground max-w-2xl mx-auto">
            From humble beginnings to becoming Juba's favorite fast-food destination
          </p>
        </div>
        
        <div className="relative">
          <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-0.5 bg-border md:transform md:-translate-x-1/2"></div>
          
          <div className="space-y-8 md:space-y-12">
            {milestones?.map((milestone, index) => (
              <div
                key={milestone?.year}
                className={`relative flex flex-col md:flex-row gap-4 md:gap-8 ${
                  index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'
                }`}
              >
                <div className={`flex-1 ${index % 2 === 0 ? 'md:text-right' : 'md:text-left'}`}>
                  <div className="bg-card p-4 md:p-6 rounded-xl shadow-lg border border-border ml-12 md:ml-0">
                    <div className="flex items-center gap-3 mb-3 md:justify-end md:flex-row-reverse">
                      <span className="text-2xl md:text-3xl font-bold text-primary">{milestone?.year}</span>
                      <div className={`w-10 h-10 md:w-12 md:h-12 rounded-full ${getColorClass(milestone?.color)} flex items-center justify-center`}>
                        <Icon name={milestone?.icon} size={20} />
                      </div>
                    </div>
                    <h3 className="text-lg md:text-xl font-bold text-foreground mb-2">{milestone?.title}</h3>
                    <p className="text-sm md:text-base text-muted-foreground leading-relaxed">{milestone?.description}</p>
                  </div>
                </div>
                
                <div className="absolute left-4 md:left-1/2 w-4 h-4 bg-primary rounded-full border-4 border-background md:transform md:-translate-x-1/2"></div>
                
                <div className="flex-1 hidden md:block"></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Timeline;